import React from "react";

export default class BrtxCardModal extends React.Component {
  render() {
    const { Bs, VARIANT, SIZE, open, value, set, sent, brtxcard } = this.props;
    return (
      <Bs
        modal
        show={open}
        keyboard={false}
        backdrop="static"
        centered
        size={SIZE.SMALL}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Bs modalheader>Zadej číslo BRTX karty</Bs>
        <Bs modalbody>
          <Bs row>
            <Bs col xs={12}>
              <Bs
                formcontrol
                value={value}
                autoFocus
                onChange={(e) =>
                  set({
                    brtxcard: {
                      ...brtxcard,
                      value: e.target.value,
                      open: true
                    },
                  })
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    sent();
                    set({
                      brtxcard: { ...brtxcard, open: false },
                    });
                  }
                }}
              ></Bs>
            </Bs>
          </Bs>
        </Bs>
        <Bs modalfooter>
          <Bs row>
            <Bs col xs={12}>
              <Bs
                button
                size={SIZE.SM}
                variant={VARIANT.SUCCESS}
                onClick={() => {
                  sent();
                  set({
                    brtxcard: { ...brtxcard, open: false },
                  });
                }}
              >
                Potvrdit
              </Bs>
            </Bs>
          </Bs>
        </Bs>
      </Bs>
    );
  }
}
